/*
  Accessible tab switching for the product tabs block.

  Follows the WAI-ARIA tabs pattern: one tab in the tab order at a time, arrow keys
  move between tabs, Home/End jump to the ends. Without JavaScript every panel
  stays visible, so the content is never hidden behind a control that cannot run.
*/
if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (this.tabs.length === 0) return;

        this.setAttribute('data-enhanced', '');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.select(0);
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          // Only the active tab stays tabbable; arrow keys move between the rest.
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        this.panels.forEach((panel, i) => {
          panel.toggleAttribute('hidden', i !== index);
        });
      }

      onKeydown(event, index) {
        const lastIndex = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = index === lastIndex ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? lastIndex : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = lastIndex;

        if (next === null) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }
    }
  );
}
